module.exports = __webpack_public_path__ + "img/2.901cbd6d.png";